/* tslint:disable */
export enum SimilarPlayType {Cast = "cast",Genre = "genre"}
